module.exports = __webpack_public_path__ + "img/pneumonia-light.77f27bec.svg";